module.exports = __webpack_public_path__ + "img/printer.1ff7cb48.svg";